<template>
	<div class="cmui-slider">
		<div class="swiper-container" >
			<div class="swiper-wrapper">
				<slot></slot>
			</div>
		    <div class="pagination"></div>
		</div>
	</div>
</template>
<script>
import $ from 'jquery';
import Swiper from '../../lib/swiper/swiper';
import sliderList from './sliderList';
import thememaker from './themeMaker';
function makeSwiperEventList(){
	var _this=this;
	var  swiperEventList=['onInit', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onSlideChangeStart', 'onSlideChangeEnd', 'onImagesReady', 'runCallbacksOnInit', 'onTransitionStart', 'onTransitionEnd', 'onTouchMoveOpposite', 'onSliderMove', 'onClick', 'onTap', 'onDoubleTap', 'onProgress', 'onReachBeginning', 'onReachEnd', 'onDestroy', 'onAutoplay', 'onAutoplayStart', 'onAutoplayStop', 'onLazyImageLoad', 'onLazyImageReady', 'onSetTransition', 'onSetTranslate', 'onSlideNextStart', 'onSlideNextEnd', 'onSlidePrevStart', 'onSlidePrevEnd', 'onPaginationRendered', 'onScroll', 'onKeyPress', 'onBeforeResize', 'onAfterResize']
	,	rs={}
	;
	swiperEventList.forEach(item=>{
		rs[item]=(...values)=>{
			this.$dispatch('cmuiSlider_'+item,this.target,...values)
		}
	})
	return rs;
}
var swiperModel={
	activeIndex:0
}
export default {
	ready:function(){
		var _this=this;
		setTimeout(function(){
			if(_this.items&&_this.items.length>1){
				if( _this.events ){
					_this.swiper=new Swiper($('.swiper-container',_this.$el), _.assign(thememaker.call(_this),makeSwiperEventList.call(_this)));
				}
				else{
					_this.swiper=new Swiper($('.swiper-container',_this.$el), thememaker.call(_this));
				}
			}else if(_this.items&&_this.items.length==1&&_this.events){//仅有一个item的时候传递事件
				_this.$dispatch('cmuiSlider_onTransitionEnd',_this.target,swiperModel)
			}
			_this.swiperIndex=sliderList.length;
			sliderList.add(_this.swiper)
		}, 0);
	},
    watch:{
		items:function(newData,oldData){
			if(_.isEqual(newData, oldData)){
				return
			}
			var _this=this;
			this.swiper && this.swiper.destroy(false, true);
			$(_this.$el).find('.pagination').empty();
			setTimeout(function(){
				if(_this.items&&_this.items.length>1){
					if( _this.events ){
						_this.swiper=new Swiper($('.swiper-container',_this.$el), _.assign(thememaker.call(_this),makeSwiperEventList.call(_this)));
					}
					else{
						_this.swiper=new Swiper($('.swiper-container',_this.$el), thememaker.call(_this));
					}
					sliderList[_this.swiperIndex]=_this.swiper;
				}else if(_this.items&&_this.items.length==1&&_this.events){
					_this.$dispatch('cmuiSlider_onTransitionEnd',_this.target,swiperModel)
				}
			}, 0);
		}
	},
	methods: {
		itemEvent: function(index, data) {
			this.$dispatch('itemEvent', this, index, data)
		}
	},
	props:{
		items: {type: Array},
		theme:{type:Number},
		col:{type:Number},
		span:{type:Number},
		space:{type:Number},
		auto:{type:Number},
		loop:{type:Boolean},
		autoplayDisable:{type:Boolean},
		target: {type:Object},
		autoHeight:{type:Boolean,default:false},
		options:{type:Object}

		, events: {
			type: Boolean
			, default: false
		}
	}
};
</script>
<style lang="scss">
@import '../../lib/swiper/swiper.css';
.swiper-pagination-bullet {
	border:0;
}
</style>
